exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3x2i4{padding:30px;height:300px;background-color:#fff;border-radius:5px}._1xL26{overflow-y:auto;height:100%}@media screen and (max-width:768px){._3x2i4{padding:15px 20px;height:460px}}", ""]);

// exports
exports.locals = {
	"root": "_3x2i4",
	"container": "_1xL26"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Article/Leasing/LeasingCars/LeasingCars.css
// module id = 3256
// module chunks = 21